import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { GlobalPropsContext } from '../../utils/globalProps';
import styles from './IframeBlock.module.scss';
import { getApprovedCookieTargets } from '../../utils/cookie';
import CookieBlocker from '../CookieBlocker';
import IframeResizer from '@iframe-resizer/react'

const iframeResizeLicenseKey = process.env.NEXT_PUBLIC_IFRAME_RESIZER_LICENSE_KEY;

const IframeBlock = ({ src, title, allow, aspectRatio }) => {
    const targets = getApprovedCookieTargets();

    const globalProps = useContext(GlobalPropsContext);
    const { activateCookieScript } = globalProps;
    const googleMapsApproved =
        targets.accept.includes('targeting') &&
        targets.accept.includes('performance');

    const aspectRatioVitec = aspectRatio === 'Vitec';

    
    return (
        <>
            {!aspectRatioVitec ? (
                googleMapsApproved || !activateCookieScript ? (
                    <div
                        className={`${styles['IframeBlock']} ${
                            styles['IframeBlock--AspectRatio-' + aspectRatio]
                        }`}>
                        <iframe
                            className={styles['IframeBlock__Iframe']}
                            loading="lazy"
                            src={src}
                            title={title}
                            allow={allow}
                        />
                    </div>
                ) : (
                    <CookieBlocker type="Iframe" url={src} />
                )
            ) : (
                <IframeResizer
                    src={src}
                    license={iframeResizeLicenseKey}
                    style={{ width: '100%', height: '100vh' }}
                    waitForLoad
                />
            )}
        </>
    );
};

IframeBlock.propTypes = {
    src: PropTypes.string,
    title: PropTypes.string,
    aspectRatio: PropTypes.string,
    allow: PropTypes.string,
};

IframeBlock.defaultProps = {
    src: null,
    title: 'Iframe',
    aspectRatio: '16_9',
    allow: null,
};

export default IframeBlock;